import React, { useState, Component } from 'react';
import { MessageSquareIcon } from 'lucide-react';
const HomeContactForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    destination: '',
    message: ''
  });
  const handleChange = e => {
    const {
      name,
      value
    } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };
  const handleSubmit = e => {
    e.preventDefault();
    // Create message for WhatsApp
    const whatsappMessage = `Hello, I'm interested in booking a trip.\n\nName: ${formData.name}\nEmail: ${formData.email}\nPhone: ${formData.phone}\nDestination: ${formData.destination || 'Not specified'}\n\nMessage: ${formData.message}`;
    // Open WhatsApp with the message
    window.open(`https://wa.me/96599886331?text=${encodeURIComponent(whatsappMessage)}`, '_blank');
  };
  return <section className="py-16 bg-gray-50" data-id="element-183">
      <div className="container mx-auto px-4" data-id="element-184">
        <div className="text-center mb-12" data-id="element-185">
          <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-186">Contact Us</h2>
          <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-187">
            Have questions about our travel packages or need help planning your
            dream vacation? Fill out the form below and we'll get back to you as
            soon as possible.
          </p>
        </div>
        <div className="max-w-3xl mx-auto" data-id="element-188">
          <form onSubmit={handleSubmit} className="bg-white p-8 rounded-lg shadow-md" data-id="element-189">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-190">
              <div data-id="element-191">
                <label htmlFor="name" className="block mb-2 text-sm font-medium text-gray-900" data-id="element-192">
                  Your Name
                </label>
                <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-red-500 focus:border-red-500 block w-full p-2.5" required data-id="element-193" />
              </div>
              <div data-id="element-194">
                <label htmlFor="email" className="block mb-2 text-sm font-medium text-gray-900" data-id="element-195">
                  Email
                </label>
                <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-red-500 focus:border-red-500 block w-full p-2.5" required data-id="element-196" />
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-197">
              <div data-id="element-198">
                <label htmlFor="phone" className="block mb-2 text-sm font-medium text-gray-900" data-id="element-199">
                  Phone Number
                </label>
                <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-red-500 focus:border-red-500 block w-full p-2.5" required data-id="element-200" />
              </div>
              <div data-id="element-201">
                <label htmlFor="destination" className="block mb-2 text-sm font-medium text-gray-900" data-id="element-202">
                  Preferred Destination (Optional)
                </label>
                <input type="text" id="destination" name="destination" value={formData.destination} onChange={handleChange} className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-red-500 focus:border-red-500 block w-full p-2.5" data-id="element-203" />
              </div>
            </div>
            <div className="mb-6" data-id="element-204">
              <label htmlFor="message" className="block mb-2 text-sm font-medium text-gray-900" data-id="element-205">
                Your Message
              </label>
              <textarea id="message" name="message" value={formData.message} onChange={handleChange} rows={4} className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-red-500 focus:border-red-500 block w-full p-2.5" placeholder="Tell us about your travel plans, questions, or special requirements..." required data-id="element-206"></textarea>
            </div>
            <button type="submit" className="w-full bg-red-600 hover:bg-red-700 text-white font-medium rounded-lg text-sm px-5 py-3 text-center flex items-center justify-center" data-id="element-207">
              <MessageSquareIcon size={18} className="mr-2" data-id="element-208" />
              Contact via WhatsApp
            </button>
            <p className="text-sm text-gray-500 mt-4 text-center" data-id="element-209">
              By submitting this form, you'll be redirected to WhatsApp to
              continue the conversation with our team.
            </p>
          </form>
        </div>
      </div>
    </section>;
};
export default HomeContactForm;